import React from 'react';
function RegionFlag(props) {
    const { value } = props;
    const clsPrefix = 'cn-ui-m-currency-select';
    if (!value) {
        return React.createElement("div", { className: `${clsPrefix}-region-flag-placeholder` });
    }
    return (React.createElement("img", { className: `${clsPrefix}-region-flag`, src: `//caijing-resource.oss-accelerate.aliyuncs.com/country/${value}.svg` }));
}
export default RegionFlag;
